import type { BlockId } from '../studio';

const CONTINUATION_LAYOUT_ID_PREFIX = '__cont__';
const CONTINUATION_LAYOUT_ID_SEPARATOR = '::';

export interface ContinuationMeta {
  readonly sourceBlockId: BlockId;
  readonly continuationIndex: number;
  readonly sourcePageIndex: number;
}

export const makeContinuationLayoutId = ({
  sourceBlockId,
  continuationIndex,
}: {
  sourceBlockId: BlockId;
  continuationIndex: number;
}): string =>
  `${CONTINUATION_LAYOUT_ID_PREFIX}${CONTINUATION_LAYOUT_ID_SEPARATOR}${sourceBlockId}${CONTINUATION_LAYOUT_ID_SEPARATOR}${continuationIndex}`;

export const isContinuationLayoutId = (id: string): boolean => id.startsWith(CONTINUATION_LAYOUT_ID_PREFIX);

export const parseContinuationLayoutId = (
  id: string,
): { sourceBlockId: BlockId; continuationIndex: number } | undefined => {
  if (!isContinuationLayoutId(id)) return undefined;
  const parts = id.split(CONTINUATION_LAYOUT_ID_SEPARATOR);
  if (parts.length !== 3) return undefined;
  const continuationIndex = Number(parts[2]);
  if (!Number.isInteger(continuationIndex) || continuationIndex < 0) return undefined;
  return { sourceBlockId: parts[1]!, continuationIndex };
};
